/* Exact native search results, styled with ZEYA product cards. */
if (!customElements.get('main-search')) {
 class MainSearch extends HTMLElement {
  constructor() {
   super();
   const input = this.querySelector('.main-search__input');
   this.querySelectorAll('.main-search__close').forEach(button => button.addEventListener('click', event => {
    event.preventDefault(); clearTimeout(this.timeout); this.controller?.abort(); this.oldSearchValue = null;
    this.classList.remove('main-search--loading', 'main-search--has-results', 'main-search--no-results', 'main-search--results-on-multiple-lines');
    this.querySelector('.main-search__results')?.setAttribute('aria-busy', 'false'); document.body.classList.remove('show-search');
    document.querySelector('.show-search-link')?.focus();
   }));
   this.addEventListener('keydown', event => { if (event.key === 'Escape') { event.preventDefault(); this.querySelector('.main-search__close').click(); } });
   if (this.dataset.quickSearch === 'true') this.initQuickSearch(input);
  }
  initQuickSearch(input) {
   const box = this.querySelector('.main-search__results');
   const footer = this.querySelector('.store-search__footer');
   const allLink = footer.querySelector('a');
   const reset = () => this.classList.remove('main-search--loading', 'main-search--has-results', 'main-search--no-results', 'main-search--results-on-multiple-lines');
   const handle = () => {
    const terms = input.value.trim();
    if (terms === this.oldSearchValue) return;
    this.oldSearchValue = terms; clearTimeout(this.timeout); this.controller?.abort();
    reset(); box.replaceChildren(); box.setAttribute('aria-busy', 'false'); footer.hidden = !terms;
    if (!terms) return;
    const form = input.closest('form');
    let link = new URL(form.action, location.origin);
    new FormData(form).forEach((value, key) => link.searchParams.set(key, value));
    link = ZeyaPreciseSearch.url(link, terms);
    allLink.href = link.href; allLink.textContent = `${theme.strings.generalSearchViewAll} “${terms}”`;
    this.classList.add('main-search--loading'); box.setAttribute('aria-busy', 'true');
    box.innerHTML = '<div class="main-search__results-spinner"><div class="loading-spinner"></div></div>';
    this.timeout = setTimeout(async () => {
     const controller = new AbortController(); this.controller = controller;
     try {
      const url = new URL(link);
      url.searchParams.set('section_id', 'zeya-precise-search');
      const response = await fetch(url, {signal: controller.signal});
      if (!response.ok) throw new Error(response.status);
      const text = await response.text();
      if (controller.signal.aborted || input.value.trim() !== terms) return;
      const template = document.createElement('template'); template.innerHTML = text;
      const list = template.content.querySelector('.zeya-precise-search-results .product-grid');
      box.replaceChildren(); reset();
      const products = [...(list?.querySelectorAll('.product-block:not(.collection-block):not(.page-block)') || [])].slice(0, 4);
      if (products.length) {
       const wrapper = document.createElement('div'); wrapper.className = 'main-search__results__products collection-listing';
       const grid = document.createElement('div'); grid.className = `product-grid ${this.dataset.gridClass}`;
       products.forEach(product => {
        product.classList.add('main-search-result');
        product.querySelectorAll('.btn.quickbuy-toggle').forEach(button => button.remove());
        product.querySelectorAll('.quickbuy-toggle').forEach(element => element.classList.remove('quickbuy-toggle'));
        grid.append(product);
       }); wrapper.append(grid); box.append(wrapper);
      }
      if (products.length) this.classList.add('main-search--has-results');
      else { this.classList.add('main-search--no-results'); const message = document.createElement('p'); message.className = 'main-search__empty-message'; message.textContent = theme.strings.generalSearchNoResultsWithoutTerms; box.append(message); }
     } catch (error) {
      if (controller.signal.aborted || input.value.trim() !== terms) return;
      reset(); box.replaceChildren(); this.classList.add('main-search--has-results');
      // Keep the full exact search link available if the preview cannot respond.
     } finally { if (input.value.trim() === terms && !controller.signal.aborted) box.setAttribute('aria-busy', 'false'); }
    }, 300);
   };
   input.addEventListener('input', handle); input.addEventListener('change', handle); input.addEventListener('focus', handle);
  }
 }
 customElements.define('main-search', MainSearch);
}
